module.exports = __webpack_public_path__ + "img/top.54329838.png";